"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableMap = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
/**
 * Observable Cache can publish new values to subscribers
 * when an item is set, deleted or when the cache is cleared.
 */
class ObservableMap {
    constructor() {
        this.cache = new Map();
        this.signal = new rxjs_1.Subject();
        /** A signal with the new values of the map */
        this.values = this.signal
            .asObservable()
            .pipe(this.convertToArray(() => this.cache.values()));
        /** A signal witht he new keys of the map */
        this.keys = this.signal
            .asObservable()
            .pipe(this.convertToArray(() => this.cache.keys()));
    }
    forEach(callbackfn, thisArg) {
        this.cache.forEach(callbackfn, thisArg);
    }
    set(key, value) {
        this.cache.set(key, value);
        this.publish();
    }
    get(key) {
        return this.cache.get(key);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        this.publish();
        return deleted;
    }
    clear() {
        this.cache.clear();
        this.publish();
    }
    has(key) {
        return this.cache.has(key);
    }
    publish() {
        this.signal.next(undefined);
    }
    convertToArray(iterator) {
        return (0, rxjs_1.pipe)((0, operators_1.startWith)(() => Array.from(iterator())), (0, operators_1.map)(() => iterator()), (0, operators_1.map)(data => Array.from(data)), (0, operators_1.shareReplay)(1));
    }
}
exports.ObservableMap = ObservableMap;
//# sourceMappingURL=observable_map.js.map